<template>
  <div class="home_reception" data-testid="settings-page">
    <div class="row">
      <div class="col-md-12">
        <visit-purposes></visit-purposes>
      </div>
    </div>
  </div>
</template>

<script>
  // import auth from '../../auth'
  // import error from '../../error'

  import VisitPurposes from './components/VisitPurposes.vue'

  export default {
    data () {
      return {
        today: '',
        waitForData: false,
        setting: require('../../variables.js'),
        useGovData: false,
        justtry: 1,
        get_params: {
          firstname: '',
          lastname: '',
          pid: ''
        },
        countries: [],
        client: {
          healthinsurance: {

          }
        },
        errors: {},
        beck: document.referrer,
        patientInfo: true
      }
    },
    components: {
      VisitPurposes
    },
    methods: {
    },
    beforeMount () {
      //
    }

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Setting/Setting.vue?4a834277